import {VisitorRepo} from './visitor-repo';

const visitorRepo = new VisitorRepo();

export {visitorRepo};
